(function () {
  'use strict';

  function initSection(section) {
    const marquee = section.querySelector('[data-marquee]');
    const track = section.querySelector('[data-track]');
    if (!marquee || !track) return;

    const scrollSpeedSec = parseInt(section.dataset.scrollSpeed, 10) || 30;
    const direction = section.dataset.scrollDirection || 'right_to_left';
    const reverse = direction === 'left_to_right';

    const LOOP_COPIES = 5;

    const reducedMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let trackWidth = 0;
    let loopWidth = 0;
    let marqueeWidth = 0;
    let minOffset = 0;
    let maxOffset = 0;
    let cycleMs = scrollSpeedSec * 1000;
    let virtualOffset = 0;
    let startTime = Date.now();
    let rafId = null;
    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startY = 0;
    let startOffset = 0;
    let activePointerId = -1;
    let isPausedByHover = false;
    let hasPointerCapture = false;

    function measure() {
      trackWidth = track.offsetWidth;
      marqueeWidth = marquee.offsetWidth;
      maxOffset = 0;
      minOffset = Math.min(0, -(trackWidth - marqueeWidth));
      var cards = track.querySelectorAll('.auto-scroll-products__product-card');
      if (cards.length >= LOOP_COPIES * 2) {
        var cardsPerCopy = cards.length / LOOP_COPIES;
        var secondCopyStart = cards[Math.floor(cardsPerCopy)];
        if (secondCopyStart) {
          loopWidth = Math.round(secondCopyStart.offsetLeft);
        } else {
          loopWidth = Math.round(trackWidth / LOOP_COPIES);
        }
      } else {
        loopWidth = Math.round(trackWidth / LOOP_COPIES);
      }
    }

    function clampOffset(value) {
      return Math.max(minOffset, Math.min(maxOffset, value));
    }

    function tick() {
      if (isDragging || isPausedByHover || reducedMotion) return;
      if (loopWidth <= 0) {
        rafId = requestAnimationFrame(tick);
        return;
      }
      var elapsed = Date.now() - startTime;
      var totalDistance = (elapsed / cycleMs) * loopWidth;
      var offsetInLoop = totalDistance % loopWidth;
      if (offsetInLoop < 0) offsetInLoop += loopWidth;
      virtualOffset = reverse ? offsetInLoop : -offsetInLoop;
      var px = Math.round(virtualOffset);
      if (px === -loopWidth || px === loopWidth) px = 0;
      track.style.transform = 'translateX(' + px + 'px)';
      rafId = requestAnimationFrame(tick);
    }

    function startAnimation() {
      measure();
      if (loopWidth <= 0) return;
      startTime = Date.now();
      rafId = requestAnimationFrame(tick);
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      hasPointerCapture = false;
      marquee.classList.remove('is-dragging');
      try {
        marquee.releasePointerCapture(activePointerId);
      } catch (e) {}
      measure();
      virtualOffset = clampOffset(virtualOffset);
      track.style.transform = 'translateX(' + virtualOffset + 'px)';
      const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
      const normalized = ((progress % 1) + 1) % 1;
      startTime = Date.now() - normalized * cycleMs;
      if (!isPausedByHover) {
        rafId = requestAnimationFrame(tick);
      }
      setTimeout(function () {
        hasDragged = false;
      }, 0);
    }

    marquee.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        hasDragged = false;
        isDragging = true;
        hasPointerCapture = false;
        activePointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        measure();
        startOffset = clampOffset(virtualOffset);
        virtualOffset = startOffset;
        track.style.transform = 'translateX(' + virtualOffset + 'px)';
        marquee.classList.add('is-dragging');
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        if (e.pointerType === 'touch') {
          marquee.setPointerCapture(e.pointerId);
          hasPointerCapture = true;
        }
      },
      { passive: true },
    );

    marquee.addEventListener(
      'pointermove',
      function (e) {
        if (!isDragging) return;
        const deltaX = e.clientX - startX;
        const deltaY = e.clientY - startY;
        if (e.pointerType === 'mouse') {
          if (!hasPointerCapture) {
            const isHorizontal = Math.abs(deltaY) <= Math.abs(deltaX) * 2;
            if (!isHorizontal) return;
            hasPointerCapture = true;
            hasDragged = true;
            marquee.setPointerCapture(e.pointerId);
          }
        } else {
          hasDragged = true;
        }
        if (e.pointerType === 'touch') e.preventDefault();
        measure();
        const delta = reverse ? -deltaX : deltaX;
        virtualOffset = clampOffset(startOffset + delta);
        track.style.transform = 'translateX(' + virtualOffset + 'px)';
      },
      { passive: false },
    );

    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);
    function resumeAnimation() {
      if (!isPausedByHover) return;
      isPausedByHover = false;
      measure();
      const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
      const normalized = ((progress % 1) + 1) % 1;
      startTime = Date.now() - normalized * cycleMs;
      rafId = requestAnimationFrame(tick);
    }

    marquee.addEventListener('pointerleave', function (e) {
      if (isDragging && e.pointerId === activePointerId) endDrag();
      if (e.pointerType === 'mouse') resumeAnimation();
    });

    marquee.addEventListener('mouseleave', function () {
      resumeAnimation();
    });

    marquee.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') {
        isPausedByHover = true;
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }
    });

    marquee.addEventListener(
      'click',
      function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const card = e.target.closest('.auto-scroll-products__product-card');
        if (card && card.href) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = card.href;
        }
      },
      true,
    );

    if (!reducedMotion) {
      startAnimation();
      window.addEventListener('resize', function () {
        if (!isDragging && loopWidth > 0) {
          measure();
          const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
          const normalized = ((progress % 1) + 1) % 1;
          startTime = Date.now() - normalized * cycleMs;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-auto-scroll-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = document.querySelector(
      '[data-auto-scroll-section][data-section-id="' + e.detail.sectionId + '"]',
    );
    if (section) initSection(section);
  });
})();
